(function () {

    /* Function that adds the tab interaction to the block */
    /* It finds the buttons and the corresponding content (with the same id) */
    /* and make the content display only for a selected tab button */
    function tabify (block) {

        /* buttons - array of tab buttons */
        /* contents - array of corresponding content */
        const buttons = Array.prototype.slice.apply(block.querySelectorAll('.js-tabs-block__button'));
        let contents = [];
        let currentTabSelected = 0;
        let currentTabFocused = 0;

        buttons.forEach(button => {
            /* Find content with the same id as button */
            const content = block.querySelector(`.js-tabs-block__content[data-tab-id="${button.dataset.tabId}"]`);
            contents.push(content ? content : null);
        });

        function toggleDisplayContent(element, ifDisplay) {
            if (element) {
                if (ifDisplay) {
                    element.classList.add('tab-active');
                    element.ariaExpanded = "true";
                } else {
                    element.classList.remove('tab-active');
                    element.ariaExpanded = "false";
                }
            }
        }
        function toggleActiveTab(element, ifActive) {
            if (element) {
                if (ifActive) {
                    element.classList.add('active');
                    element.ariaSelected = "true";
                } else {
                    element.classList.remove('active');
                    element.ariaSelected = "false";
                }
            }
        }
        function toggleFocusTab(element, ifFocus) {
            if (element) {
                if (ifFocus) {
                    element.setAttribute("tabindex", 0);
                    element.focus();
                } else {
                    element.setAttribute("tabindex", -1);
                }
            }
        }
        function moveFocusNext() {
            currentTabFocused++;
            if (currentTabFocused >= buttons.length) {
                currentTabFocused = 0;
            }
        }
        function moveFocusPrev() {
            currentTabFocused--;
            if (currentTabFocused < 0) {
                currentTabFocused = buttons.length - 1;
            }
        }
        function setTab( index ) {
            toggleDisplayContent(contents[currentTabSelected], false);
            toggleActiveTab(buttons[currentTabSelected], false);
            toggleDisplayContent(contents[index], true);
            toggleActiveTab(buttons[index], true);
            currentTabSelected = index;
        }
        function handleKeyDown (e) {
            if (e.keyCode === 39 || e.keyCode === 37) {
                toggleFocusTab(buttons[currentTabFocused], false);
                if (e.keyCode === 39) { moveFocusNext(); }
                else if (e.keyCode === 37) { moveFocusPrev(); }
                toggleFocusTab(buttons[currentTabFocused], true);
            }
        }
        function init() {
            /* clear state */
            contents.forEach(item => { toggleDisplayContent(item, false); });
            buttons.forEach(item => { toggleActiveTab(item, false); });
            buttons.forEach(item => { toggleFocusTab(item, false); });

            /* init state */
            setTab(currentTabSelected);

            /* event listeners */
            buttons.forEach((item, index) => item.onclick = event => setTab(index));
            buttons.forEach((item) => item.onkeydown = event => handleKeyDown(event));
        }

        init();
    }

    [...document.querySelectorAll('.js-tabs-block')]
        .forEach(x => tabify(x));
}());
